// extracted by mini-css-extract-plugin
export var divider = "_fq-7";
export var itemsToggle = "_fq-8";
export var mergeModal = "_fq-1";
export var optionCard = "_fq-4";
export var radioGroup = "_fq-6";
export var radioOption = "_fq-0";
export var selected = "_fq-5";
export var shipmentOptions = "_fq-2";
export var tableOptions = "_fq-3";